import type { ReactNode } from 'react';

import { SWReactIcons } from '@similarweb/icons';

import { CountryService, WORLDWIDE_COUNTRY_ID } from 'services/country/country';

import {
  StyledChartCardBodyWrapper,
  StyledChartCardCountryFlag,
  StyledChartCardHeaderInfo,
  StyledChartCardSubtitle,
  StyledChartCard,
  StyledChartCardFooter,
  StyledChartCardHeader,
  StyledChartCardTitle,
  StyledChartCardContainer,
} from './styles';
import { SWLOGO } from './SWLogo';

type ChartCardProps = {
  title: ReactNode;
  date?: ReactNode;
  countryCode?: number;
  withBorder?: boolean;
  extendedFooterPadding?: boolean;
  overlay?: ReactNode;
  children: ReactNode;
};

export const ChartCard = ({
  title,
  date,
  countryCode = WORLDWIDE_COUNTRY_ID,
  withBorder,
  extendedFooterPadding = true,
  overlay,
  children,
}: ChartCardProps) => {
  return (
    <StyledChartCardContainer>
      <StyledChartCard>
        <StyledChartCardHeader withBorder={withBorder}>
          <StyledChartCardTitle>{title}</StyledChartCardTitle>
          <StyledChartCardHeaderInfo>
            {date ? (
              <>
                <SWReactIcons iconName={'daily-ranking'} size="xs" />
                <StyledChartCardSubtitle>{date}</StyledChartCardSubtitle>
              </>
            ) : null}
            <StyledChartCardCountryFlag countryCode={countryCode} size="xs" dataAutomationIconName="flag" />
            <StyledChartCardSubtitle>{CountryService.getCountryName(countryCode)}</StyledChartCardSubtitle>
          </StyledChartCardHeaderInfo>
        </StyledChartCardHeader>
        {overlay ? (
          <StyledChartCardBodyWrapper>
            {overlay}
            {children}
          </StyledChartCardBodyWrapper>
        ) : (
          children
        )}
        <StyledChartCardFooter extendedPadding={extendedFooterPadding}>
          <SWLOGO />
        </StyledChartCardFooter>
      </StyledChartCard>
    </StyledChartCardContainer>
  );
};
